document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener(
    'click',
    (e) => {
      const button = e.target.closest('button[name="add"]');
      if (!button) return;

      const productForm = button.closest('product-form');
      if (!productForm) return;

      let firstErrorFieldset = null;

      // Nettoyage des erreurs précédentes
      productForm.querySelectorAll('.custom-option-error').forEach(el => el.remove());
      productForm.querySelectorAll('.has-error').forEach(el => el.classList.remove('has-error'));

      const fieldsets = productForm.querySelectorAll('.custom-color-fieldset');

      for (const fieldset of fieldsets) {
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        const hasSelection = Array.from(radios).some(r => r.checked);

        if (!hasSelection) {
          e.preventDefault();
          e.stopImmediatePropagation();

          fieldset.classList.add('has-error');

          const legend = fieldset.querySelector('legend');
          const label = legend ? legend.textContent.trim() : 'Cette option';

          const error = document.createElement('p');
          error.className = 'custom-option-error';
          error.textContent = `Veuillez sélectionner : ${label}`;

          fieldset.appendChild(error);

          if (!firstErrorFieldset) firstErrorFieldset = fieldset;
        }
      }

      // Scroll vers la première erreur
      if (firstErrorFieldset) {
        firstErrorFieldset.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },
    true // capture → AVANT Dawn
  );
});

// Supprime l'erreur dès qu'une option est sélectionnée
document.addEventListener('change', (e) => {
  const radio = e.target;
  if (!radio.matches('.custom-color-fieldset input[type="radio"]')) return;

  const fieldset = radio.closest('.custom-color-fieldset');
  if (!fieldset) return;

  // Supprime la classe d’erreur
  fieldset.classList.remove('has-error');

  // Supprime le message d’erreur
  const error = fieldset.querySelector('.custom-option-error');
  if (error) error.remove();
});
